import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import {
    ClassListComponent,
    PupilTaskComponent,
    SmartSprintComponent,
    LessonNotStartedComponent,
    PrivilegeIconComponent,
    PupilTaskChoiceComponent,
    PupilTaskExerciseComponent,
    PupilTaskNoQuestionComponent,
    PupilMagicBoxExerciseComponent,
    PupilExerciseComponent,
    PupilQuestionComponent,
    PupilTaskQuestionComponent,
    PupilChoiceComponent,
    CoachComponent
} from './components';

import { PupilService } from '@student/services/pupil.service';
import { SharedModule } from '@app/shared/shared.module';
import { NgxBootstrapModule } from '@app/ngx-bootstrap/ngx-bootstrap.module';
import { PreviewImgModule } from '@app/shared/components/preview-img/preview-img.module';
import { SvgIconModule } from '@app/core/components/svg-icon/svg-icon.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const studentRoutes: Routes = [
    { path: '', redirectTo: 'class_list', pathMatch: 'full' },
    { path: 'class_list', component: ClassListComponent },
    { path: 'coach/:class_id', component: CoachComponent },
    { path: 'class_list/:class_id', component: PupilChoiceComponent },
    { path: 'pupil/:pupil_id', component: PupilTaskChoiceComponent },
    { path: 'pupil/:pupil_name/lesson_not_started', component: LessonNotStartedComponent },
    { path: 'smart_sprint/pupil/:pupil_id/:lesson_id', component: SmartSprintComponent },
    { path: 'pupil/:pupil_id/:lesson_id/:card_id', component: PupilTaskComponent }
];

@NgModule({
    imports: [
        SvgIconModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        SharedModule,
        PreviewImgModule,
        NgxBootstrapModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule.forChild(studentRoutes)
    ],
    exports: [RouterModule],
    providers: [PupilService],
    declarations: [
        PupilTaskComponent,
        ClassListComponent,
        PrivilegeIconComponent,
        PupilChoiceComponent,
        PupilTaskChoiceComponent,
        PupilTaskExerciseComponent,
        PupilTaskNoQuestionComponent,
        PupilMagicBoxExerciseComponent,
        PupilExerciseComponent,
        PupilQuestionComponent,
        PupilTaskQuestionComponent,
        SmartSprintComponent,
        LessonNotStartedComponent,
        CoachComponent
    ]
})
export class StudentModule {}
